import { NsForm } from 'components/common/ns-form/NsForm';
import { NsEmailInput } from 'components/common/ns-email-input/NsEmailInput';
import NsContent from 'components/common/ns-content/NsContent';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { Error } from 'components/common/error/Error';
import { useNavigation } from 'hooks/useNavigation';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useMaskPII } from 'hooks/useMaskPII';
import { shallowEqual, useSelector } from 'react-redux';
import {
  selectEmail,
  selectErrors,
  selectIsLoading, setEmail, setInitialState,
  slice as emailCaptureSlice
} from 'state/email-capture/email-capture-slice';
import { useValidateEmailThunk } from 'hooks/useEmailValidationThunk';
import React from 'react';
import NsInputterEvent from '../../../common/ns-inputter/NsInputterEvent';

export const emailCaptureFormTestId = 'emailCaptureFormTestId';

export const EmailCaptureForm = () => {
  const { eventTypes, next } = useNavigation();
  const dispatch = useAppDispatch();
  const { mask } = useMaskPII();

  const email = useSelector(selectEmail, shallowEqual);
  const isLoading = useSelector(selectIsLoading, shallowEqual);
  const apiErrors = useSelector(selectErrors, shallowEqual);
  const validateEmailThunk = useValidateEmailThunk(emailCaptureSlice);

  const handleChange = (event: NsInputterEvent) => {
    const { value } = (event.target as HTMLInputElement);

    dispatch(setEmail(value));
  };

  const handleGoNext = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      await dispatch(validateEmailThunk(email));
      next({ eventType: eventTypes.NEXT });
    } catch (error) {
      error && console.error(error);
    }
  };

  const handleSkip = () => {
    dispatch(setInitialState());
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <NsContent data-testid={emailCaptureFormTestId}>
      <NsForm onSubmit={handleGoNext}>
        <NsEmailInput
          id="email"
          name="email"
          label="Email"
          value={email}
          onChange={handleChange}
          inputAttributes={mask}
        />
        <Error errors={apiErrors} />
        <NsPrimaryCta isLoading={isLoading}>Save your quote</NsPrimaryCta>
      </NsForm>
      <NsSecondaryCta type="text" onClick={handleSkip}>
        No thanks. Take me to my quote
      </NsSecondaryCta>
      <p>
        If you choose to share your email, we&apos;ll only use it to send your
        tariff options. You won&apos;t receive anything else unless you agree
        to it.
      </p>
    </NsContent>
  )
}

export default EmailCaptureForm;